<template>
  <div class="game-controls__time">
    <div class="game-controls__time__text">
      <div class="game-controls__time__text--first">time to</div>
      <div class="game-controls__time__text--second">next round</div>
    </div>
    <div class="game-controls__time__countdown">
      <div class="game-controls__time__countdown__value">
        {{ turnTimer | formatTime }}
      </div>
      <div class="game-controls__time__countdown__seconds">s</div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "Time",
  data() {
    return {
      turnTimer: 0,
    };
  },
  computed: {
    ...mapGetters(["activeGame"]),
    timerShouldEnd() {
      return _.get(this.activeGame, "timerShouldEnd");
    },
  },
  mounted() {
    setInterval(this.updateTimer, 500);
  },
  methods: {
    updateTimer() {
      const timer = this.timerShouldEnd - new Date();
      this.turnTimer = timer > 0 ? timer : 0;
    },
  },
};
</script>
